<div class="message-container">
  <div class="avatar">
    <img [src]="imgPath" alt="Avatar" />
  </div>
  <div class="loader mt-1"></div>
</div>
